import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { LoaderService } from '../util/loader.service';
@Injectable({
    providedIn: 'root'
})
export class LocalDbService {
    private dbPromise: Promise<Storage>;

    constructor(private storage: Storage, public loader: LoaderService) {
        this.dbPromise = this.storage.create();
    }

    private async getDb(): Promise<Storage> {
        return await this.dbPromise;
    }

    async localPost(key: string, value: any) {
        const db = await this.getDb();
        return await db.set(key, value);
    }

    async localGet(key: string) {
        const db = await this.getDb();
        return await db.get(key);
    }

    async localDelete(key: string) {
        const db = await this.getDb();
        return await db.remove(key);
    }

    async localClear() {
        const db = await this.getDb();
        return await db.clear();
    }
}